import { nbaFeedLabFixture } from "./generated/nba-feed-lab";
export const gameScreenStatsByGameId = nbaFeedLabFixture.gameScreens;
export const nykAtlantaGameStats = gameScreenStatsByGameId["0022501143"];
export const porDenverGameStats = gameScreenStatsByGameId["0022501147"];
